import { render, staticRenderFns } from "./punch.vue?vue&type=template&id=016be5e4&"
import script from "./punch.vue?vue&type=script&lang=js&"
export * from "./punch.vue?vue&type=script&lang=js&"
import style0 from "./punch.vue?vue&type=style&index=0&id=016be5e4&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports